// Import barber images
import danyImg from '../assets/barbers/dany_fagundes.png';
import elijahImg from '../assets/barbers/elijah_de_castro.jpg';
import luisImg from '../assets/barbers/luis_gomez.png';
import daveImg from '../assets/barbers/dave_g.png';

export interface Barber {
  name: string;
  image: string;
  bio: string;
}

export interface Location {
  id: string;
  name: string;
  city: string;
  address: string;
  fullAddress: string;
  phone: string;
  email: string;
  instagram: string;
  instagramHandle: string;
  bookingUrl?: string;
  bookingStatus: 'active' | 'coming-soon';
  mapEmbedUrl: string;
  barbers: Barber[];
  hours: {
    monday: string;
    tuesday: string;
    wednesday: string;
    thursday: string;
    friday: string;
    saturday: string;
    sunday: string;
  };
}

export const locations: Location[] = [
  {
    id: 'san-francisco',
    name: 'San Francisco',
    city: 'San Francisco',
    address: '1018 Bush St',
    fullAddress: '1018 Bush St, San Francisco, CA 94109',
    phone: '415-580-7565',
    email: 'Metropolitan.sf.barbershop@gmail.com',
    instagram: 'https://www.instagram.com/metropolitan_barbershop1/profilecard/?igsh=dHdrbzVobHJmd2E3',
    instagramHandle: '@metropolitan_barbershop1',
    bookingUrl: 'https://metropolitan.setmore.com/',
    bookingStatus: 'active',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0191825788657!2d-122.41941368468178!3d37.79057927975589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808c5b7b3e7f%3A0x7c3f7bfa2b5e8a1f!2s1018%20Bush%20St%2C%20San%20Francisco%2C%20CA%2094109!5e0!3m2!1sen!2sus!4v1644360000000!5m2!1sen!2sus',
    barbers: [
      {
        name: "Dany Fagundes",
        image: danyImg,
        bio: "Master barber with over 10 years of experience in classic and modern cuts."
      },
      {
        name: "Elijah De Castro",
        image: elijahImg,
        bio: "Specialist in fades and contemporary styling with attention to detail."
      },
      {
        name: "Luis Gomez",
        image: luisImg,
        bio: "Expert in traditional barbering techniques and straight razor shaves."
      },
      {
        name: "Dave G",
        image: daveImg,
        bio: "Skilled barber delivering sharp cuts and clean grooming with a friendly chair-side touch."
      }
    ],
    hours: {
      monday: 'CLOSED',
      tuesday: '10:00-7:00',
      wednesday: '10:00-7:00',
      thursday: '10:00-7:00',
      friday: '10:00-7:00',
      saturday: '10:00-5:00',
      sunday: 'CLOSED'
    }
  },
  {
    id: 'san-jose',
    name: 'San Jose',
    city: 'San Jose',
    address: '1691 Branham Lane',
    fullAddress: '1691 Branham Lane, San Jose, CA 95118',
    phone: '669-275-2902',
    email: 'metropolitan.sj.barbershop@gmail.com',
    instagram: 'https://www.instagram.com/metropolitan_barbershop2?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr',
    instagramHandle: '@metropolitan_barbershop2',
    bookingUrl: 'http://metropolitanbarbershop2.setmore.com/',
    bookingStatus: 'active',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3175.4591825788657!2d-121.85941368468178!3d37.29057927975589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808e3331b5b3e7f%3A0x7c3f7bfa2b5e8a1f!2s1691%20Branham%20Ln%2C%20San%20Jose%2C%20CA%2095118!5e0!3m2!1sen!2sus!4v1644360000000!5m2!1sen!2sus',
    barbers: [], // Will be updated when barbers are assigned
    hours: {
      monday: 'CLOSED',
      tuesday: '10:00-7:00',
      wednesday: '10:00-7:00',
      thursday: '10:00-7:00',
      friday: '10:00-7:00',
      saturday: '10:00-5:00',
      sunday: 'CLOSED'
    }
  }
];

export const getLocationById = (id: string): Location | undefined => {
  return locations.find(location => location.id === id);
};

export const getLocationByCity = (city: string): Location | undefined => {
  return locations.find(location => location.city.toLowerCase() === city.toLowerCase());
}; 